var InFlight = InFlight || {};

InFlight.i18n = (function () {
  var setupPromise = undefined;
  var language = 'en';

  function setupLanguage() {
    setupPromise = new Promise(function (resolve, reject) {
      var languageObj = {};
      var storedLanguage = localStorage.getItem('language');
      var storedLanguageData = sessionStorage.getItem('languageData');
      if (storedLanguage) {
        language = storedLanguage;
      }
      if (storedLanguageData) {
        languageObj = JSON.parse(storedLanguageData);
      }
      if (languageObj[language]) {
        //loadLanguage(language, languageObj);
        $.i18n({ locale: language })
          .load(languageObj)
          .done(function () {
            resolve();
          });
      } else {
        $.getJSON(InFlight.NLX.Cfg.Customer.getI18nEnJson())
          .done(function (data) {
            languageObj[language] = data;
            //  loadLanguage(language, languageObj);
            sessionStorage.setItem('languageData', JSON.stringify(languageObj));
            $.i18n({ locale: language })
              .load(languageObj)
              .done(function () {
                resolve();
              });
          })
          .fail(function () {
            reject();
          });
      }
    });
  }

  function localize(language, languageObj) {
    setupPromise.then(function () {
      preProcessIFDatai18n();
      $('body').i18n();
    });
  }

  function preProcessIFDatai18n() {
    var i18nElements = $('body [data-if-i18n]');
    for (var i = 0; i < i18nElements.length; i++) {
      var $i18n = $(i18nElements[i]);
      var attr = $i18n.data('if-i18n');
      var split = attr.split(' ');
      for (var j = 0; j < split.length; j++) {
        var term = split[j];
        var splitTerm = term.split(':');
        if (splitTerm.length === 1) {
          $i18n.data('i18n', splitTerm[0]);
        } else {
          $i18n.attr(splitTerm[0], $.i18n(splitTerm[1]));
        }
      }
    }
  }

  function getTerm(langTerm) {
    var languageData = JSON.parse(sessionStorage.getItem('languageData'));
    if (languageData) {
      return languageData[language][langTerm];
    }

  }

  function clearLanguage() {
    sessionStorage.removeItem('languageData');
  }

  return {
    setup: setupLanguage,
    localize: localize,
    clear: clearLanguage,
    getTerm: getTerm
  };
})();
